import { BsFillCaretDownFill } from "react-icons/bs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Accordian = ({ onClick, faq, i, activeTab }) => {
  return (
    <div className="border-b group transition-all duration-300 overflow-hidden">
      <button
        onClick={onClick}
        className="w-full flex justify-between items-center focus:outline-none p-4 md:px-6 md:py-5"
      >
        <h3 className="font-semibold md:text-xl text-lg text-left">
          {faq.question}
        </h3>
        <BsFillCaretDownFill
          className={`${
            i === activeTab ? "-rotate-180" : "rotate-0"
          } h-4 w-4 mt-1 transition-all duration-300`}
        />
      </button>
      <p
        className={`${
          i === activeTab ? "h-auto pb-4" : "h-0 overflow-hidden"
        } transition-all duration-300 px-4 md:px-6 text-base font-normal text-secondary-550`}
      >
        {faq.answer}
      </p>
    </div>
  );
};

const FAQ = ({ title, description, faqs, faqLimit, className, titleClass, descriptionClass, containerClass }) => {
  const [activeTab, setActiveTab] = useState(null);
  const { t } = useTranslation();

  const toggleTab = (index) => {
    setActiveTab(index === activeTab ? null : index);
  };

  return (
    <div className={`${className}`}>
      <div className={`container`}>
        {title && <h3 className={`${titleClass? titleClass : "text-black"} text-center`}>{title}</h3>}
        {description && (
          <h2 className={`${descriptionClass? descriptionClass : "md:text-xl text-lg"} text-center mt-1 mb-8 sm:mb-16`}>
            {description}
          </h2>
        )}
        <div>
            {faqs.length > 0 ? (
                <div className={`${containerClass ? containerClass : "mx-auto my-4"} w-full`}>
                {faqs? faqs.map((faq,i)=>
                    <Accordian key={i} onClick={() => toggleTab(i)} faq={faq} i={i} activeTab={activeTab} />
                    ) : faqs.map((faq, i) =>
                    faqLimit ? (
                    i < faqLimit ? (
                        <Accordian key={i} onClick={() => toggleTab(i)} faq={faq} i={i} activeTab={activeTab} />
                    ) : ("")
                    ) : <Accordian key={i} onClick={() => toggleTab(i)} faq={faq} i={i} activeTab={activeTab} />
                )}
                </div>
            ) : (
                <div className="container py-10 flex justify-center items-center h-[30vh]">
                  <span className="text-xl">{t("FAQs not updated yet.")}</span>
                </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
